import React from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import { IDriverCardProps } from "./types";
import { useTranslation } from "react-i18next";

const DriverCard: React.FC<IDriverCardProps> = ({
  licensePlate,
  carModel,
  carMake,
  driverName,
  driverPhone,
  carImageUrl = "",
  status,
}) => {
  const { t } = useTranslation("webReceipt");
  return (
    <div className="w-full flex flex-col items-stretch">
      <div className="rounded-lg p-4 flex flex-col gap-2 mx-5 mt-2 mb-2 max-w-full bg-white">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-base inline-block bg-nobel-50 rounded-lg px-2 py-1  font-bold text-mineshaft-900 mb-2">
              {licensePlate}
            </div>
            {(carMake || carModel) && (
              <div className="text-base font-bold text-mineshaft-900">
                {[carMake, carModel].filter(Boolean).join(" ")}
              </div>
            )}
            <div className="text-base font-semibold text-mineshaft-900">
              {driverName} &bull;{" "}
              {driverPhone.replace(/^(\+852)(\d+)/, "$1 $2")}
            </div>
          </div>
          {carImageUrl && (
            <img
              src={carImageUrl}
              alt="Car"
              className="w-20 h-20 object-contain mr-4"
              style={{ transform: "scaleX(-1)" }}
            />
          )}
        </div>
        {status !== "completed" && status !== "cancelled" && driverPhone && (
          <a
            href={`tel:${driverPhone.replace(/\s/g, "")}`}
            className="flex items-center justify-center gap-2 rounded-full py-2 px-4 font-semibold text-base transition bg-brand-blue-light text-brand-blue"
            style={{ textDecoration: "none" }}
          >
            <PhoneIcon sx={{ fontSize: 20 }} className="text-brand-blue" />
            {t("commonCallDriverButton")}
          </a>
        )}
      </div>
    </div>
  );
};

export default DriverCard;
